import type { StatsigUser } from "@statsig/react-bindings"

type BootstrapSessionUser = {
  email?: string | null
  id?: string | null
  name?: string | null
}

type BootstrapOrganization = {
  id?: string | null
  name?: string | null
  slug?: string | null
}

type CurrentDealershipUser = {
  email?: string | null
  isDemo?: boolean | null
  name?: string | null
  userId?: string | null
  dealership?: {
    id?: string | null
    role?: string | null
    slug?: string | null
  } | null
}

type CurrentDealership = {
  _id: string
  betterAuthOrgId?: string | null
  name: string
  slug: string
}

export function buildBootstrapStatsigUser(input: {
  activeOrganization?: BootstrapOrganization | null
  sessionUser?: BootstrapSessionUser | null
}): StatsigUser {
  const { activeOrganization, sessionUser } = input

  return {
    userID: sessionUser?.id ?? sessionUser?.email ?? activeOrganization?.id ?? "anonymous",
    email: sessionUser?.email ?? undefined,
    customIDs: {
      betterAuthOrgID: activeOrganization?.id ?? undefined,
    },
    custom: {
      organizationName: activeOrganization?.name ?? undefined,
      organizationSlug: activeOrganization?.slug ?? undefined,
      signedIn: Boolean(sessionUser?.id ?? sessionUser?.email),
      userName: sessionUser?.name ?? undefined,
    },
  }
}

export function buildDealershipStatsigUser(input: {
  dealership: CurrentDealership
  isSuperAdmin: boolean
  user: CurrentDealershipUser
}): StatsigUser {
  const { dealership, isSuperAdmin, user } = input

  return {
    userID: user.userId ?? user.email ?? dealership._id,
    email: user.email ?? undefined,
    customIDs: {
      betterAuthOrgID: dealership.betterAuthOrgId ?? undefined,
      dealershipID: dealership._id,
    },
    custom: {
      dealershipName: dealership.name,
      dealershipSlug: dealership.slug,
      isDemo: user.isDemo ?? undefined,
      isSuperAdmin,
      role: user.dealership?.role ?? undefined,
      userName: user.name ?? undefined,
    },
  }
}
